"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _pointsMall = require("@/api/pointsMall");
var _default2 = require("../default");
var _sendFrom = _interopRequireDefault(require("./sendFrom"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'editDelivery',
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    editData: {
      type: Object,
      required: null
    }
  },
  components: {
    SendFrom: _sendFrom.default
  },
  data: function data() {
    return {
      formItem: {
        carrierPhone: '',
        deliveryCarrier: '',
        deliveryMark: '',
        expressCode: '',
        expressNumber: '',
        id: 0
      },
      rules: _default2.postRules,
      logistics: [],
      loadingBtn: false,
      dvisible: false
    };
  },
  watch: {
    visible: {
      handler: function handler(val) {
        this.dvisible = val;
        if (val) this.formItem = _objectSpread(_objectSpread({}, this.editData), {}, {
          expressNumber: this.editData.expressNumber ? this.editData.expressNumber : this.editData.trackingNumber
        });
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('onCloseVisible');
      this.$refs.formItem.resetFields();
    },
    handleSubmitSuccess: function handleSubmitSuccess() {
      this.$emit('onSubmitSuccess');
      this.loadingBtn = false;
      this.$refs.formItem.resetFields();
    },
    //提交
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.loadingBtn = true;
          var _this$formItem = _this.formItem,
            carrierPhone = _this$formItem.carrierPhone,
            deliveryCarrier = _this$formItem.deliveryCarrier,
            deliveryMark = _this$formItem.deliveryMark,
            expressCode = _this$formItem.expressCode,
            expressNumber = _this$formItem.expressNumber,
            id = _this$formItem.id;
          var data = {
            carrierPhone: carrierPhone,
            deliveryCarrier: deliveryCarrier,
            deliveryMark: deliveryMark,
            expressCode: expressCode,
            expressNumber: expressNumber,
            id: id
          };
          (0, _pointsMall.orderInvoiceUpdateApi)(data).then(function (res) {
            _this.$message.success('修改发货单配送信息成功');
            _this.handleSubmitSuccess();
          }).catch(function (res) {
            _this.loadingBtn = false;
          });
        }
      });
    })
  }
};